import React from "react";
import Image from "next/image";
import RichTextBlock from "@/storyblok/block-library/rich-texts/RichTextBlock";
import { cn } from "@/storyblok/utils/cn";
import TextImage from "../images/TextImage";

export default function TextWImage({
  text,
  backgroundColor,
  image,
  textColor,
  imagePosition,
}) {
  const isImageLeft = imagePosition === "left";

  const backgroundClasses = cn({
    "bg-bg-color-white": backgroundColor === "bg-white",
    "bg-bg-color-light": backgroundColor === "bg-light",
    "bg-bg-color-dark": backgroundColor === "bg-dark",
    "bg-bg-color-grey": backgroundColor === "bg-grey",
    "bg-bg-color-orange": backgroundColor === "bg-orange",
  });

  const textClasses = cn({
    "text-textPrimary": textColor === "textPrimary",
    "text-textSecondary": textColor === "textSecondary",
    "text-textBlack": textColor === "textBlack",
    "text-textLight": textColor === "textLight",
    "text-textWhite": textColor === "textWhite",
    "text-textGrey": textColor === "textGrey",
    "text-textOrange": textColor === "textOrange",
  });

  const imageClasses = cn("w-full", {
    "md:angle-left": !isImageLeft,
    "md:angle-right": isImageLeft,
  });

  return (
    <div className={`w-full ${backgroundClasses} `}>
      <div
        className={`justify-center flex flex-col md:flex-row md:py-24 md:px-4 md:max-w-7xl  ${
          isImageLeft ? "md:flex-row" : "md:flex-row-reverse"
        } items-center gap-8 mx-auto `}
      >
        <div className="w-full md:w-6/12 ">
          {image && <TextImage image={image} className={imageClasses} />}
        </div>
        <div className="w-full md:w-6/12 p-2">
          {text && <RichTextBlock content={text} className={textClasses} />}
        </div>
      </div>
    </div>
  );
}
